//PA Extensions
export const paExtensionQueryCol = `) {
     
  data
  {
runDate
sequenceNumber
carrier
Account
Group
MemberID
OriginalPANumber
OriginalPATermedDate
NewPANumber
NewPAEffectiveDate
NewPATermDate
PAType
ProductID
AgentCode
ReasonCode
DrugStatus
IgnoreDrugStatus
  },totalCount
}
}
`;

//Rejected Extensions
export const rejectedExtensionQueryCol = `) {
  data
      {
      runDate
      sequenceNumber
      carrier
      Account 
      Group
      MemberID    
      OriginalPANumber    
      OriginalPATermedDate    
      PAType  
      ReasonPANotExtended 
      GPI
      },totalCount
  }
  }
  `;

//Configurations
export const configurationQueryCol = `) {
  data
  {
  runDate
  sequenceNumber
  carrier
  MSC
  Client
  DrugName
  GNLevel
  ExtensionDurationInMonths
  GPIsNDCs
  ClinicalDecision
},totalCount

}

}
`;

//MEM_BY_PLAN_YEAR_ALL
export const MEM_BY_PLAN_YEAR_ALL = `){
data {
MSIID
MemberID
Carrier
PlanType
Account
Group
StartDate
EndDate
ChangeDate
PlanYear
EndDateForPlanYear
RowNum
Sequence
MBIPYPTRank
MCPYTRANK
MCAPYPTRANK
MCAGPYPTRANK
}
totalCount
message
success
}
}`;

//GROUP_BY_YEAR_ALL
export const GROUP_BY_YEAR_ALL = `){
data {
  Account
    PlanCode
    PlanCode5
    PlanCodePALevel
    PlanYear
    StartDate
    EndDate
    EndDateForPlanYear
    Carrier
    PlanType
    BenCD
    RankNum,
    Group
}
totalCount
message
success
}
}`;

//DupeQA
export const DUPE_QA = `){
data {
  MSIID
    MemberID
    Carrier
    PlanType
    Account
    Group
    StartDate
    EndDate
    ChangeDate
    PlanYear
}
totalCount
message
success
}
}`;

//Formulary
export const FORMULARY = `){
  data {
    PlanCode5,
    FormID,
    GPI,
    MSC,    
    Tier,
    PACD,
    QLCD,
    QLDays,
    QLMDD,
    QLQuantity,
    QLTypeCD
  }
  totalCount
  message
  success
  }
  }`;

//PA Compound Details
export const PACompoundDetail = `){
    data {
      Carrier,
      MemberID,
      Account,
      Group,
      PANumber,
      ProductCode,
      ProductName,
      CostType,
      CostValue,
      MACList,
      CostSource,
      QL,
      PartB
    }
    totalCount
    message
    success
    }
    }`;

//PA Price Details
export const PAPriceDetail = `){
  data {
    MemberID
    CarrierCode
    AccountNumber
    GroupCode
    PriorAuthorizationNumber
    TroopScheduleCode
    EgwpTroopScheduleCode
    PpScheduleName
    PriceScheduleName
    CopayScheduleName
    CopayStepNumber
    CopayIndicator
    ClientPriceSchedule
    ProductSelectionCode
    MacScheduleCode
    PnpStatus
    CostType
    CostValue
    FeeScheduleName
    FeeScheduleStepNumber
    IncentiveFeeScheduleStep
    CostSource
    BenefitMaxAccumCode
    LifeMaxAccumCode
    PharmacyAmountDueSchedule
    ClientAmountDueSchedule
    CsrAccumulatedDeductibleSchedule
    CsrAccumulatedOopSchedule
    OtcIndicator
  }
  totalCount
  message
  success
  }
  }`;

//
export const PriorAuthDetail = `){
  data {
     HighDollarOr,
     QlOr,
     RxbQlOr,
     AgeOr,
     MedOr,
     OpioidDurOr,
     TceOr,
     MpaMemberId,
     MPACarrier,
     MPAAccount,
     MPAGroup,
     MPAPriorAuthorizationNumber,
     MPAStatus,
     MPAStart,
     MPAEnd,
     MPAChangeDt,
     MPAChgTm,
     MPAChgUsr,
     MPAAgentCd,
     PaaAgentCdDesc,
     MPAPAType,
     MPAProductCode,
     DervMPAProductCode,
     MpaMsc,
     MPARxOtc,
     MPADescription,
     MPARsnCd,
     ParRsnCdDesc,
     PnoDrugStatus,
     MPAIgnPaStatusCd,
     MPAIgnPaStatusCdDesc,
     PnoAmtDueType,
     PnoAmtDueDays,
     PnoAmtDueMax,
     PnoAmtDueBasis,
     PnoDlyDoseMin,
     PnoDlyDoseMax,
     PnoDlyDoseQual,
     PnoQtyMin,
     PnoQtyMax,
     PnoDsMin,
     PnoDsMax,
     PnoQtyDsCompMax,
     PnoPerQtyType,
     PnoPerQtyDays,
     PnoPerQtyMax,
     PnoPerDsType,
     PnoPerDsDays,
     PnoPerDsMax,
     PnoPerQtyDsCompMax,
     PnoPerPsqDays,
     PnoPerPsqMax,
     PnoPerFillsType,
     PnoPerFillsDays,
     PnoPerFillsMax,
     PnoPerFillsMaxQty,
     PnoRefillLimitsMax,
     PnoRefillExpireAfterDay,
     PnoPtdFrom,
     PnoAgeMin,
     PnoAgeMax,
     PnoAcuteDoseDaysMax,
     PnoMaintDoseDayMax,
     PnoPatResCodeList,
     PnoPatResCodeLstQual,
     DglDiagnosisList,
     PnoDiagnosisListQual,
     SnhSuperNetworkId,
     PnoSuperNetworkQual,
     PnoMessageCde,
     PnoMessageType,
     MpuDaOr,
     MpuDcOr,
     MpuDdOr,
     MpuHdOr,
     MpuIdOr,
     MpuLdOr,
     MpuMcOr,
     MpuMnOr,
     MpuMxOr,
     MpuPaOr,
     MpuPgOr,
     MpuSxOr,
     MpuTdOr,
     MpuMedLimitOrFlg,
     MpuMedLimitOr,
     MpuErOverPrecOr,
     MpuThreshPharm,
     MpuThresPresc,
     MpuPerFillDs,
     MppOrOtc,
     MppOrPrefFrm,
     MppOrRxrestr,
     MppOrDur,
     MppOrNdcList,
     MppOrNdcPerFills,
     MppOvrdeNdcContTherpy,
     MppOrNdcDx,
     MppOrGpiList,
     MppOrGpiPerFills,
     MppOvrdeGpiContTherpy,
     MppOrGpiDx,
     MppOvrdeSpecialtyPgm,
     MppClarificationOvrde,
     MppOvrdeCustLocation,
     MppMemberElgDiagCode,
     MprTierOr,
     MprFormularyStatus,
     MteTierOrCd,
     MteTier1,
     MteTier2,
     MteTier3,
     MteTier4,
     MteTier5,
     MteTier6,
     MteTier7,
     MteTier8,
     MteTier9,
     MteTier10,
     MteTier11,
     MteTier12,
     MpyMbrMultPaOvrFlag,
     PnzRefillLimitsMaxNbr,
     PnzRefillexpireafterdays,
     LatestChgTs
  }
  totalCount
  message
  success
  }
  }`;

//Product Details
export const ProductDetail = `){
  data {
      AuthTypeCode
      AuthProductCode
      AuthDerivedProductCode
      AuthMSC
      AuthRxOtc
      AuthDescription
      AuthCount
      GPI14
      MSC
      RxOtc
      NDC
      ReprProductDescription
  }
  totalCount
  message
  success
  }
  }`;


//Product Details
export const ProductCodeSetDetail = `){
  data {
      PrdKey
 ,NdcUpcHri
 ,OriginCd
 ,Ndc9
 ,PrdDescAbbr
 ,Msc
 ,Gpi2
 ,Gpi2Name
 ,Gpi4
 ,Gpi4Name
 ,Gpi6
 ,Gpi6Name
 ,Gpi8
 ,Gpi8Name
 ,Gpi10
 ,Gpi10Name
 ,Gpi12
 ,Gpi12Name
 ,DervGpi12Name
 ,Gpi14
 ,Gpi14Name
 ,ProdName
 ,Trademark
 ,DfrmDesc
 ,Strength
 ,LabelerType
 ,StrengthUom
 ,RxOtcCd
 ,TpeCd
 ,RepackCd
 ,UdCd
 ,PackSize
 ,PackUom
 ,PackQty
 ,PackTotalQty
 ,DesiCd
 ,InnerpackCd
 ,ClinicpackCd
 ,FdbGcn
 ,FdbGcnSeq
 ,FdbBrndName
 ,LabelName
 ,NdaFlag
 ,AndaFlag
 ,BlaFlag
 ,RefListDrugFlag
 ,MktgStart
 ,MktgEnd
 ,MktgCatCd
 ,MktgCatCdDesc
 ,Status
 ,AddDate
 ,StartDate
 ,InactiveDate
 ,TermDate
 ,RowNum
  }
  totalCount
  message
  success
  }
  }`;

//MMT 3 Report  
//MMT Skip Details
export const MmtSkipDetail = `){
  data {
     ActionNeeded,
     ExtensionStatus,
     MemberId,
     CarrierId,
     AccountId,
     GroupId,
     MpaPaNumber,
     EffectiveDate,
     TermedDate,
     PaType,
     ProductId,
     AgentCode,
     ReasonCode,
     DrugStatus,
     IgnoreDrugStatus,
     PriorAuthNotes
    }
    lastRefreshedDate
    message
    success
  }
  }`;

//MMT Load Details
export const MmtLoadDetail = `){
data {
  Extendskipqa
      Carlscenario
      Carlfinalevaluation
      Carlclinicaleval
      Carlqleval
      Carlnote
      Mpamemid
      Mpacarr
      Mpaacct
      Mpagrp
      Mpapanum
      Pnodrugstatus
      Mpaignpastatuscd
      Authmelend
      Nextmelstart
      Nextmcagmacmpapanumforauthprefix
      MemberId
      CarrierId
      AccountId
      GroupId
      PaNumber
      EffectiveDate
      TermedDate
      PaType
      ProductId
      AgentCode
      ReasonCode
      DrugStatus
      IgnoreDrugStatus
      PriorAuthNotes
      MscCode
      IncidentId
      QuantityMinimum
      QuantityMaximum
      DaysSupplyMinimum
      DaysSupplyMaximum
      QtydsCompMaximum
      PeriodQuantityType
      PeriodQuantityDays
      PeriodQuantityMaximum
      PeriodDsType
      PeriodDsDays
      PeriodDsMaximum
      PeriodQtydsCompMax
      PeriodFillsType
      PeriodFillsDays
      PeriodFillsMaximum
      RefillLimitsMaxNbr
      RefillExpireAfterDays
      AmtDueType
      AmtDueDays
      AmtDueMaximum
      AmtDueBasis
      PtdFromDate
      PatientAgeMinimum
      PatientAgeMaximum
      DailyDoseMinimum
      DailyDoseMaximum
      DailyDoseQualifier
      AcuteDosingDaysMax
      MaintDosingdayMax
      OtcOverride
      PackagingExceptions
      FdaTherapeuticEquiv
      RouteOfAdministration
      MaintDrugStatus
      BrandgenericEdit
      SexExclusion
      SpecialtyListCode
      SpecialtyListQualifier
      DiagnosisList
      DiagnosisListQualifier
      PrescriberNetworkId
      PrescriberNetworkQualifier
      PharmacyNetworkId
      PharmacyNetworkCarrierCode
      PharmacyNetworkRegionCode
      PharmacyNetworkQualifier
      PrescriberId
      PrescriberIdQualifier
      PrescriberIdState
      PrescriberIdStatusQualifier
      PharmacyId
      PharmacyIdQualifier
      FamilyCoverage
      DependentMinimumAge
      DependentMaximumAge
      PrefProdNdcLabeler
      PrefProdNdcProduct
      PrefProdNdcPackage
      FormularyAltGpi
      FormularyAltNdcLabeler
      FormularyAltNdcProduct
      FormularyAltNdcPackage
      MessageCode
      MessageType
      PriorAuthExpMessage
      NbrFillsRemainingMessage
      DrugStatusList
      DrugStatusListStatus
      PlanFillLimitsOverrideMultisource
      PlanFillLimitsOverrideProduct
      CtProtocolLevel
      CtScheduleId
      DrugStatusTable
      PatientAgeOverride
      QuantityQualifier
      WorkersCompensationBenefitBlock
      IncidentProductOverride
      ReferralStatusOverride
      FdaNonapproval
      TransbenExcludeFromCt
      PeriodPkgSzQtyType
      PeriodPkgSzQtyDays
      PeriodPkgSzQtyMaximum
      FormularyManagementServices
      SuperNetwork
      SuperNetworkQualifier
      FillsmaximumQty
      PlanFillLimitsOverrideTc
      TransBenefitOverride
      IncentiveSchedule
      TaxonomyListId
      TaxonomyListQualifier
      TaxonomyListDrugStatus
      PtdSource
      PtdFromDate2
      DiscountBenefitProcessing
      StateListWorkersComp
      UnbreakablePackageSr34611
      MbrEligSbmcompare
      MbrEligMedicare
      MbrEligDsLevel
      ClarificationOverride
      CustLocpatientResid
      LongTermCare
      PharmacyNetwork
      CareFacility
      CareNetwork
      PrescriberNetwork
      ProvprodValidation
      PrescriberSpecialty
      Compounds
      NdcList
      NdcPeriodFills
      NdcContingentTherapy
      GpiList
      GpiPeriodFills
      GpiContingentTherapy
      DeaClass
      MaxDaysSupplyqty
      RefillLimits
      ThirdPartyException
      DosageForm
      Desi
      MedicaidProduct
      TherapeuticCategory
      PreferredFormulary
      RxRestrictions
      Dur
      MbrProviderPharmacy
      MbrProviderMd
      DynamicPaOverride
      PaError
      SpecialtyProgram
      PharmacistValidation
      LevelOfService
      MbrElgDiagnosisCode
      CagPosClaimTimelyFiling
      CagMailretailClaimInactivityEdits
      PrescriberValidation
      ProdQualValidation
      PharmacyValidation
      NdcDiagnosisList
      GpiDiagnosisList
      MicPartialMatch
      MicRoa
      Period4thQtrDsType
      Period4thQtrDsDays
      Period4thQtrDsMaximum
      PatientResidenceCodeList
      PatientResidenceCodeListQualifier
      RxOtcInd
      MdNetworkDrugStatus
      MpyMemberMultiplePaOvrrideFlag
      MultisourceCode
      ProductSelectionCode
      Status
      GenericIndicatorOverride
      BrandgenericIndicator
      PharmacyPriceSched
      ClientPriceSched
      PhcyPatientPaySched
      ClientPatientPaySched
      CostTypeOverride
      CostValue
      CopaySchedule
      CopayScheduleStep
      FeeSchedule
      FeeScheduleStep
      IncentiveFeeSchedule
      IncentiveFeeScheduleStep
      BenefitMaxScheduleFrom
      BenefitMaxScheduleThru
      BenefitMaxDatesQualifier
      BenefitMaximumAccumulationLevel
      BenefitMaxAdjustmentReasonCodeList
      BenefitMaxAdjustmentReasonCodeStatus
      BenefitMaxSchedule
      BenefitMaxAccumCode
      BenefitMaxSubperiodType
      BenefitMaxPriorSubperiodCarryover
      BenefitMaxPeriodCarryover
      DeductibleScheduleFrom
      DeductibleScheduleThru
      DeductibleDatesQualifier
      DeductibleAccumulationLevel
      DeductibleAdjustmentReasonCodeList
      DeductibleAdjustmentReasonCodeStatus
      DeductibleAccumulationCodeList
      DeductibleSchedule
      DeductSchedAccumCde
      FourthQtrCarryover
      Ded4thQtrAdjRsnCdeList
      Ded4thQtrAdjRsnCdeStatus
      OopScheduleFrom
      OopScheduleThru
      OopDatesQualifier
      OopAccumulationLevel
      OopAdjustmentReasonCodeList
      OopAdjustmentReasonCodeStatus
      OopAccumulationCodeList
      OutOfPocketMaxSched
      OopAccumCode
      Oop4thQtrCarryover
      Oop4thQtrAdjRsnCdeList
      Oop4thQtrAdjRsnCodeStatus
      LifetimeAccumulationLevel
      LifetimeAdjustmentReasonCodeList
      LifetimeAdjReasonCodeStatus
      LifetimeBenefitMaxSched
      LifetimeBenefitMaxAccumCode
      EgwpTroop
      OverrideBenefitMaximumSchedule
      OverrideBenefitMaximumCode
      OverrideDeductibleSchedule
      OverrideDeductibleCode
      OverrideOutOfPocketSchedule
      OverrideOutOfPocketCode
      OverrideLifetimeBenefitMaxSchedule
      OverrideLifetimeBenefitMaxCode
      DeductibleSubperiodType
      OopSubperiodType
      Tier
      FormularyStatus
      TierOverride
      Tier01
      Tier02
      Tier03
      Tier04
      Tier05
      Tier06
      Tier07
      Tier08
      Tier09
      Tier10
      Tier11
      Tier12
      DrugAllergy
      DrugDiseaseInferred
      DrugdrugInteraction
      HighDose
      IngredientDuplication
      LowDose
      DrugdiseaseReported
      InsufficientDuration
      ExcessiveDuration
      DrugAge
      Drugpregnancy
      DrugGender
      Therapeutic
      Medlimit
      OverusePrecaution
      MedLimitOverride
      PharmacyThreshold
      PrescriberThreshold
      NttPerFillDs
      TrOopSchedule
      OtcIndicator
      CostSource
      BenefitMaximumAccumulationCodeList
      LifetimeBenefitMaximumAccumulationCodeList
      AmountDuePharmacy
      AmountDueClient
      HimCsrAccumDedSched
      HimCsrAccumOopSched
      DiagnosisMessageSchedule
      DiagnosisMessageType
    }   
    lastRefreshedDate
    message
    success
  }
  }`;

// MMT1 Scenario Details (single dataset) - actual backend query fields
export const MmtByScenarioDetail = `){
  data {
    CarlStep
    CarlScenario
    CarlFinalEvaluation
    CarlClinicalEval
    CarlQlEval
    AuthCount
  }
  lastRefreshedDate
  message
  success
  }
  }`;

// MMT Manual Details
export const MntManualDetails = `){
 data {
      AuthCategory
      DateAssessed
      AssessmentOutcome
      DateLoaded
      ExtendSkipQa
      CarlScenario
      CarlFinalEvaluation
      CarlClinicalEval
      CarlQlEval
      CarlNote
      MpaMemid
      MpaCarr
      MpaAcct
      MpaGrp
      MpaPaNumber
      PnoDrugStatus
      MpaIgnPaStatusCd
      AuthMelEnd
      NextMelStart
      NextMcagMacMpaPaNumForAuthPrefix
      MemberId
      CarrierId
      AccountId
      GroupId
      PaNumber
      EffectiveDate
      TermedDate
      PaType
      ProductId
      AgentCode
      ReasonCode
      DrugStatus
      IgnoreDrugStatus
      PriorAuthNotes
      MscCode
      IncidentId
      QuantityMinimum
      QuantityMaximum
      DaysSupplyMinimum
      DaysSupplyMaximum
      QtyDsCompMaximum
      PeriodQuantityType
      PeriodQuantityDays
      PeriodQuantityMaximum
      PeriodDsType
      PeriodDsDays
      PeriodDsMaximum
      PeriodQtyDsCompMax
      PeriodFillsType
      PeriodFillsDays
      PeriodFillsMaximum
      RefillLimitsMaxNbr
      RefillExpireAfterDays
      AmtDueType
      AmtDueDays
      AmtDueMaximum
      AmtDueBasis
      PtdFromDate
      PatientAgeMinimum
      PatientAgeMaximum
      DailyDoseMinimum
      DailyDoseMaximum
      DailyDoseQualifier
      AcuteDosingDaysMax
      MaintDosingDayMax
      OtcOverride
      PackagingExceptions
      FdaTherapeuticEquiv
      RouteOfAdministration
      MaintDrugStatus
      BrandGenericEdit
      SexExclusion
      SpecialtyListCode
      SpecialtyListQualifier
      DiagnosisList
      DiagnosisListQualifier
      PrescriberNetworkId
      PrescriberNetworkQualifier
      PharmacyNetworkId
      PharmacyNetworkCarrierCode
      PharmacyNetworkRegionCode
      PharmacyNetworkQualifier
      PrescriberId
      PrescriberIdQualifier
      PrescriberIdState
      PrescriberIdStatusQualifier
      PharmacyId
      PharmacyIdQualifier
      FamilyCoverage
      DependentMinimumAge
      DependentMaximumAge
      PrefProdNdcLabeler
      PrefProdNdcProduct
      PrefProdNdcPackage
      FormularyAltGpi
      FormularyAltNdcLabeler
      FormularyAltNdcProduct
      FormularyAltNdcPackage
      MessageCode
      MessageType
      PriorAuthExpMessage
      NbrFillsRemainingMessage
      DrugStatusList
      DrugStatusListStatus
      PlanFillLimitsOverrideMultisource
      PlanFillLimitsOverrideProduct
      CtProtocolLevel
      CtScheduleId
      DrugStatusTable
      PatientAgeOverride
      QuantityQualifier
      WorkersCompensationBenefitBlock
      IncidentProductOverride
      ReferralStatusOverride
      FdaNonApproval
      TransBenExcludeFromCt
      PeriodPkgSzQtyType
      PeriodPkgSzQtyDays
      PeriodPkgSzQtyMaximum
      FormularyManagementServices
      SuperNetwork
      SuperNetworkQualifier
      FillsMaximumQty
      PlanFillLimitsOverrideTc
      TransBenefitOverride
      IncentiveSchedule
      TaxonomyListId
      TaxonomyListQualifier
      TaxonomyListDrugStatus
      PtdSource
      PtdFromDate2
      DiscountBenefitProcessing
      StateListWorkersComp
      UnbreakablePackageSr34611
      MbrEligSbmCompare
      MbrEligMedicare
      MbrEligDsLevel
      ClarificationOverride
      CustLocPatientResid
      LongTermCare
      PharmacyNetwork
      CareFacility
      CareNetwork
      PrescriberNetwork
      ProvProdValidation
      PrescriberSpecialty
      Compounds
      NdcList
      NdcPeriodFills
      NdcContingentTherapy
      GpiList
      GpiPeriodFills
      GpiContingentTherapy
      DeaClass
      MaxDaysSupplyQty
      RefillLimits
      ThirdPartyException
      DosageForm
      Desi
      MedicaidProduct
      TherapeuticCategory
      PreferredFormulary
      RxRestrictions
      Dur
      MbrProviderPharmacy
      MbrProviderMd
      DynamicPaOverride
      PaError
      SpecialtyProgram
      PharmacistValidation
      LevelOfService
      MbrElgDiagnosisCode
      CagPosClaimTimelyFiling
      CagMailRetailClaimInactivityEdits
      PrescriberValidation
      ProdQualValidation
      PharmacyValidation
      NdcDiagnosisList
      GpiDiagnosisList
      MicPartialMatch
      MicRoa
      Period4thQtrDsType
      Period4thQtrDsDays
      Period4thQtrDsMaximum
      PatientResidenceCodeList
      PatientResidenceCodeListQualifier
      RxOtcInd
      MdNetworkDrugStatus
      MpyMemberMultiplePaOvrrideFlag
      MultiSourceCode
      ProductSelectionCode
      Status
      GenericIndicatorOverride
      BrandGenericIndicator
      PharmacyPriceSched
      ClientPriceSched
      PhcyPatientPaySched
      ClientPatientPaySched
      CostTypeOverride
      CostValue
      CopaySchedule
      CopayScheduleStep
      FeeSchedule
      FeeScheduleStep
      IncentiveFeeSchedule
      IncentiveFeeScheduleStep
      BenefitMaxScheduleFrom
      BenefitMaxScheduleThru
      BenefitMaxDatesQualifier
      BenefitMaximumAccumulationLevel
      BenefitMaxAdjustmentReasonCodeList
      BenefitMaxAdjustmentReasonCodeStatus
      BenefitMaxSchedule
      BenefitMaxAccumCode
      BenefitMaxSubPeriodType
      BenefitMaxPriorSubPeriodCarryOver
      BenefitMaxPeriodCarryOver
      DeductibleScheduleFrom
      DeductibleScheduleThru
      DeductibleDatesQualifier
      DeductibleAccumulationLevel
      DeductibleAdjustmentReasonCodeList
      DeductibleAdjustmentReasonCodeStatus
      DeductibleAccumulationCodeList
      DeductibleSchedule
      DeductSchedAccumCde
      FourthQtrCarryOver
      Ded4thQtrAdjRsnCdeList
      Ded4thQtrAdjRsnCdeStatus
      OopScheduleFrom
      OopScheduleThru
      OopDatesQualifier
      OopAccumulationLevel
      OopAdjustmentReasonCodeList
      OopAdjustmentReasonCodeStatus
      OopAccumulationCodeList
      OutOfPocketMaxSched
      OopAccumCode
      Oop4thQtrCarryOver
      Oop4thQtrAdjRsnCdeList
      Oop4thQtrAdjRsnCodeStatus
      LifetimeAccumulationLevel
      LifetimeAdjustmentReasonCodeList
      LifetimeAdjReasonCodeStatus
      LifetimeBenefitMaxSched
      LifetimeBenefitMaxAccumCode
      TrOopSchedule
      EgwpTroop
      OtcIndicator
      CostSource
      OverrideBenefitMaximumSchedule
      OverrideBenefitMaximumCode
      OverrideDeductibleSchedule
      OverrideDeductibleCode
      OverrideOutOfPocketSchedule
      OverrideOutOfPocketCode
      OverrideLifetimeBenefitMaxSchedule
      OverrideLifetimeBenefitMaxCode
      DeductibleSubPeriodType
      OopSubPeriodType
      BenefitMaximumAccumulationCodeList
      LifetimeBenefitMaximumAccumulationCodeList
      AmountDuePharmacy
      AmountDueClient
      HimCsrAccumDedSched
      HimCsrAccumOopSched
      Tier
      FormularyStatus
      TierOverride
      Tier01
      Tier02
      Tier03
      Tier04
      Tier05
      Tier06
      Tier07
      Tier08
      Tier09
      Tier10
      Tier11
      Tier12
      DrugAllergy
      DrugDiseaseInferred
      DrugDrugInteraction
      HighDose
      IngredientDuplication
      LowDose
      DrugDiseaseReported
      InsufficientDuration
      ExcessiveDuration
      DrugAge
      DrugPregnancy
      DrugGender
      Therapeutic
      Medlimit
      OverusePrecaution
      MedLimitOverride
      PharmacyThreshold
      PrescriberThreshold
      NttPerFillDs
    }
    lastRefreshedDate
    message
    success
  }
}`

export const MntCompoundDetails = `){
data
{
  AuthCategory
      DateAssessed
      AssessmentOutcome
      DateLoaded
      ExtendSkipQa
      CarlScenario
      CarlFinalEvaluation
      CarlClinicalEval
      CarlQlEval
      CarlNote
      MpaMemid
      MpaCarr
      MpaAcct
      MpaGrp
      MpaPaNum
      PnoDrugStatus
      MpaIgnPaStatusCd
      AuthMelEnd
      NextMelStart
      NextMcagMacMpaPaNumForAuthPrefix
      MemberId
      CarrierId
      AccountId
      GroupId
      PaNumber
      EffectiveDate
      TermedDate
      PaType
      ProductId
      AgentCode
      ReasonCode
      DrugStatus
      IgnoreDrugStatus
      PriorAuthNotes
      MscCode
      IncidentId
      QuantityMinimum
      QuantityMaximum
      DaysSupplyMinimum
      DaysSupplyMaximum
      QtyDsCompMaximum
      PeriodQuantityType
      PeriodQuantityDays
      PeriodQuantityMaximum
      PeriodDsType
      PeriodDsDays
      PeriodDsMaximum
      PeriodQtyDsCompMax
      PeriodFillsType
      PeriodFillsDays
      PeriodFillsMaximum
      RefillLimitsMaxNbr
      RefillExpireAfterDays
      AmtDueType
      AmtDueDays
      AmtDueMaximum
      AmtDueBasis
      PtdFromDate
      PatientAgeMinimum
      PatientAgeMaximum
      DailyDoseMinimum
      DailyDoseMaximum
      DailyDoseQualifier
      AcuteDosingDaysMax
      MaintDosingDayMax
      OtcOverride
      PackagingExceptions
      FdaTherapeuticEquiv
      RouteOfAdministration
      MaintDrugStatus
      BrandGenericEdit
      SexExclusion
      SpecialtyListCode
      SpecialtyListQualifier
      DiagnosisList
      DiagnosisListQualifier
      PrescriberNetworkId
      PrescriberNetworkQualifier
      PharmacyNetworkId
      PharmacyNetworkCarrierCode
      PharmacyNetworkRegionCode
      PharmacyNetworkQualifier
      PrescriberId
      PrescriberIdQualifier
      PrescriberIdState
      PrescriberIdStatusQualifier
      PharmacyId
      PharmacyIdQualifier
      FamilyCoverage
      DependentMinimumAge
      DependentMaximumAge
      PrefProdNdcLabeler
      PrefProdNdcProduct
      PrefProdNdcPackage
      FormularyAltGpi
      FormularyAltNdcLabeler
      FormularyAltNdcProduct
      FormularyAltNdcPackage
      MessageCode
      MessageType
      PriorAuthExpMessage
      NbrFillsRemainingMessage
      DrugStatusList
      DrugStatusListStatus
      PlanFillLimitsOverrideMultisource
      PlanFillLimitsOverrideProduct
      CtProtocolLevel
      CtScheduleId
      DrugStatusTable
      PatientAgeOverride
      QuantityQualifier
      WorkersCompensationBenefitBlock
      IncidentProductOverride
      ReferralStatusOverride
      FdaNonApproval
      TransBenExcludeFromCt
      PeriodPkgSzQtyType
      PeriodPkgSzQtyDays
      PeriodPkgSzQtyMaximum
      FormularyManagementServices
      SuperNetwork
      SuperNetworkQualifier
      PlanFillLimitsOverrideTc
      TransBenefitOverride
      IncentiveSchedule
      TaxonomyListId
      TaxonomyListQualifier
      TaxonomyListDrugStatus
      PtdSource
      PtdFromDate2
      DiscountBenefitProcessing
      StateListWorkerSComp
      UnbreakablePackageSr34611
      MbrEligSbmCompare
      MbrEligMedicare
      MbrEligDsLevel
      ClarificationOverride
      CustLocPatientResid
      LongTermCare
      PharmacyNetwork
      CareFacility
      CareNetwork
      PrescriberNetwork
      ProvProdValidation
      PrescriberSpecialty
      Compounds
      NdcList
      NdcPeriodFills
      NdcContingentTherapy
      GpiList
      GpiPeriodFills
      GpiContingentTherapy
      DeaClass
      MaxDaysSupplyQty
      RefillLimits
      ThirdPartyException
      DosageForm
      Desi
      MedicaidProduct
      TherapeuticCategory
      PreferredFormulary
      RxRestrictions
      Dur
      MbrProviderPharmacy
      MbrProviderMd
      DynamicPaOverride
      PaError
      SpecialtyProgram
      PharmacistValidation
      LevelOfService
      MbrElgDiagnosisCode
      CagPosClaimTimelyFiling
      CagMailRetailClaimInactivityEdits
      PrescriberValidation
      ProdQualValidation
      PharmacyValidation
      NdcDiagnosisList
      GpiDiagnosisList
      MicPartialMatch
      MicRoa
      Period4thQtrDsType
      Period4thQtrDsDays
      Period4thQtrDsMaximum
      PatientResidenceCodeList
      PatientResidenceCodeListQualifier
      RxOtcInd
      MdNetworkDrugStatus
      MpyMemberMultiplePaOvrrideFlag
      GenericIndicatorOverride
      BrandGenericIndicator
      CopayScheduleStep
      BenefitMaxScheduleFrom
      BenefitMaxScheduleThru
      BenefitMaxDatesQualifier
      BenefitMaximumAccumulationLevel
      BenefitMaxAdjustmentReasonCodeList
      BenefitMaxAdjustmentReasonCodeStatus
      BenefitMaxSchedule
      BenefitMaxAccumCode
      BenefitMaxSubPeriodType
      BenefitMaxPriorSubPeriodCarryOver
      BenefitMaxPeriodCarryOver
      DeductibleScheduleFrom
      DeductibleScheduleThru
      DeductibleDatesQualifier
      DeductibleAccumulationLevel
      DeductibleAdjustmentReasonCodeList
      DeductibleAdjustmentReasonCodeStatus
      DeductibleAccumulationCodeList
      DeductibleSchedule
      DeductSchedAccumCde
      FourthQtrCarryOver
      Ded4thQtrAdjRsnCdeList
      Ded4thQtrAdjRsnCdeStatus
      OopScheduleFrom
      OopScheduleThru
      OopDatesQualifier
      OopAccumulationLevel
      OopAdjustmentReasonCodeList
      OopAdjustmentReasonCodeStatus
      OopAccumulationCodeList
      OutOfPocketMaxSched
      OopAccumCode
      Oop4thQtrCarryOver
      Oop4thQtrAdjRsnCdeList
      Oop4thQtrAdjRsnCodeStatus
      LifetimeAccumulationLevel
      LifetimeAdjustmentReasonCodeList
      LifetimeAdjReasonCodeStatus
      LifetimeBenefitMaxSched
      LifetimeBenefitMaxAccumCode
      EgwpTroop
      OverrideBenefitMaximumSchedule
      OverrideBenefitMaximumCode
      OverrideDeductibleSchedule
      OverrideDeductibleCode
      OverrideOutOfPocketSchedule
      OverrideOutOfPocketCode
      OverrideLifetimeBenefitMaxSchedule
      OverrideLifetimeBenefitMaxCode
      DeductibleSubPeriodType
      OopSubPeriodType
      Tier
      FormularyStatus
      TierOverride
      Tier01
      Tier02
      Tier03
      Tier04
      Tier05
      Tier06
      Tier07
      Tier08
      Tier09
      Tier10
      Tier11
      Tier12
      DrugAllergy
      DrugDiseaseInferred
      DrugDrugInteraction
      HighDose
      IngredientDuplication
      LowDose
      DrugDiseaseReported
      InsufficientDuration
      ExcessiveDuration
      DrugAge
      DrugPregnancy
      DrugGender
      Therapeutic
      Medlimit
      OverusePrecaution
      MedLimitOverride
      PharmacyThreshold
      PrescriberThreshold
      NttPerFillDs
      McnProductCode
      McnCostSource
      McnCostTypeOr
      McnCostValueOr
      TrOopSchedule
      OtcIndicator
      CostSource
      BenefitMaximumAccumulationCodeList
      LifetimeBenefitMaximumAccumulationCodeList
      AmountDuePharmacy
      AmountDueClient
      HimCsrAccumDedSched
      HimCsrAccumOopSched
      FillsMaximumQty
      CopaySchedule
      FeeSchedule
      FeeScheduleStep
      IncentiveFeeSchedule
      IncentiveFeeScheduleStep
      MultiSourceCode
      ProductSelectionCode
      Status
      PharmacyPriceSched
      ClientPriceSched
      PhcyPatientPaySched
      ClientPatientPaySched
      CostTypeOverride
      CostValue
    }
    lastRefreshedDate
    message
    success
  }
}`

// Coca Annual - Annual Report Detail
export const AnnualReportDetail = `){
  data {
    CarlScenario
    ExtensionStatus,    
    AuthorizationCount,
    JobTimeStamp
  }
  lastRefreshedDate
  message
  success
  }
  }`;

export const CocaSkipsDetail = `){
  data {
   ActionNeeded,
   ExtensionStatus,
   MemberId,
   CarrierId,
   AccountId,
   GroupId,
   MpaPaNumber,
   EffectiveDate,
   TermedDate,
   PaType,
   ProductId,
   AgentCode,
   ReasonCode,
   DrugStatus,
   IgnoreDrugStatus,
   PriorAuthNotes,
   JobTimeStamp
  }
  lastRefreshedDate
  message
  success
  }
  }`;

export const CocaByScenario = `){
  data {
    CarlStep,
    CarlScenario,
    CarlFinalEvaluation,
    CarlClinicalEval,
    CarlQlEval,
    AuthCount,
    JobTimeStamp
  }
  lastRefreshedDate
  message
  success
  }
  }`;

